// src/store/modules/citySelect.js

const state = {
  // 选中的城市信息
  selectedCities: {
    from: null,    // 出发地
    to: null,      // 目的地
    current: null  // 当前选择的城市（用于"请选择地市"）
  },
  // 当前选择类型
  currentSelectionType: null
};

const mutations = {
  // 设置出发地
  SET_FROM_CITY(state, city) {
    state.selectedCities.from = city;
  },
  
  // 设置目的地
  SET_TO_CITY(state, city) {
    state.selectedCities.to = city;
  },
  
  // 设置当前选择的城市（用于顶部的"请选择地市"）
  SET_CURRENT_CITY(state, city) {
    state.selectedCities.current = city;
  },
  
  // 设置当前选择类型（记录用户点击的是哪个城市选择项）
  SET_CURRENT_SELECTION_TYPE(state, type) {
    state.currentSelectionType = type;
  },
  
  // 根据选择类型设置对应的城市
  SET_CITY_BY_SELECTION_TYPE(state, city) {
    const type = state.currentSelectionType;
    if (type === 'from') {
      state.selectedCities.from = city;
    } else if (type === 'to') {
      state.selectedCities.to = city;
    } else if (type === 'current') {
      state.selectedCities.current = city;
    }
    // 清除当前选择类型
    state.currentSelectionType = null;
  },
  
  // 清除所有城市选择
  CLEAR_ALL_CITIES(state) {
    state.selectedCities = {
      from: null,
      to: null,
      current: null
    };
    state.currentSelectionType = null;
  },
  
  // 清除特定城市选择
  CLEAR_CITY(state, type) {
    if (type === 'from') {
      state.selectedCities.from = null;
    } else if (type === 'to') {
      state.selectedCities.to = null;
    } else if (type === 'current') {
      state.selectedCities.current = null;
    }
  },
  
  // 清除出发地和目的地
  CLEAR_FROM_AND_TO_CITIES(state) {
    state.selectedCities.from = null;
    state.selectedCities.to = null;
  }
};

const actions = {
  // 设置出发地
  setFromCity({ commit }, city) {
    commit('SET_FROM_CITY', city);
  },
  
  // 设置目的地
  setToCity({ commit }, city) {
    commit('SET_TO_CITY', city);
  },
  
  // 设置当前选择的城市（用于顶部的"请选择地市"）
  setCurrentCity({ commit }, city) {
    commit('SET_CURRENT_CITY', city);
  },
  
  // 设置当前选择类型（记录用户点击的是哪个城市选择项）
  setCurrentSelectionType({ commit }, type) {
    commit('SET_CURRENT_SELECTION_TYPE', type);
  },
  
  // 根据选择类型设置对应的城市
  setCityBySelectionType({ commit }, city) {
    commit('SET_CITY_BY_SELECTION_TYPE', city);
  },
  
  // 清除所有城市选择
  clearAllCities({ commit }) {
    commit('CLEAR_ALL_CITIES');
  },
  
  // 清除特定城市选择
  clearCity({ commit }, type) {
    commit('CLEAR_CITY', type);
  },
  
  // 清除出发地和目的地
  clearFromAndToCities({ commit }) {
    commit('CLEAR_FROM_AND_TO_CITIES');
  }
};

const getters = {
  selectedCities: state => state.selectedCities,
  currentSelectionType: state => state.currentSelectionType,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};


// WEBPACK FOOTER //
// ./src/store/modules/citySelect.js